import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfigService } from 'app/core/services/config.service';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { TopicsService } from '../topics.service';

@Component({
  selector: 'itpx-svg-uploader-modal',
  templateUrl: './svg-uploader-modal.component.html',
  styleUrls: ['./svg-uploader-modal.component.css']
})
export class SvgUploaderModalComponent implements OnInit {

  @Input() data: any
  public allowedFormats = ['svg'];
  public counterFilesUploaded: number = 0;
  public maxItemsUploaded: number = 1;
  public file: any
  public fileName: string
  public svg: any
  
  constructor(
    private fb: FormBuilder,
    private service: TopicsService,
    private modalService: SmartModalService,) { }

  ngOnInit() {}

  public onChange(event: any) {
    this.counterFilesUploaded++;
    this.file = event.target.files[0]
    this.fileName = event.target.files[0].name
    this.onUploadSVG(this.file);
  }

  onUploadSVG(file) {
    let fileReader = new FileReader();
    fileReader.onload = (e) => { this.svg = fileReader.result }
    fileReader.readAsText(file);
  }

  onSaveClicked() {
    this.service.uploadSvgIcon({key: this.data.code, value: this.svg})
    .subscribe(_ => this.modalService.sendResult(true))
  }

  onCancel() {
    this.modalService.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/topics/svg-uploader-modal/svg-uploader-modal.component.ts